import React from "react";
import { CirclePicker } from 'react-color';
import PropTypes from 'prop-types';

export default class ColorPicker extends React.Component {

    state = {
        colorPickerAdjustedWidth: undefined
    }

    componentDidMount = () => {
        window.addEventListener('click', this.props.onClose);
        
        this.adjustTheWidth();
    }

    componentWillUnmount = () => {
        window.removeEventListener('click', this.props.onClose);
    }

    adjustTheWidth = () => {        
        if(!this.props.parentElmSelector) return;

        // Get the element's bounding box
        const colorElm = document.querySelector('.circle-picker');
        const parentElm = document.querySelector(this.props.parentElmSelector);
        
        if(colorElm && parentElm){
            const colorElmRect = colorElm.getBoundingClientRect();
            const parentElmRect = parentElm.getBoundingClientRect();

            const distanceFromRight = parentElmRect.right - colorElmRect.left;
            const colorPickerAdjustedWidth = Math.floor(distanceFromRight / 42) * 42; // 42 is the width of each color swatch in the color picker
            
            this.setState({
                colorPickerAdjustedWidth: colorPickerAdjustedWidth < 252 ? colorPickerAdjustedWidth : 252 // 252 is the default width of the color picker
            });
        }
    }

    onChange = (color, event) => {
        // color = {
        //   hex: '#333',
        //   rgb: {
        //     r: 51,
        //     g: 51,
        //     b: 51,
        //     a: 1,
        //   },
        //   hsl: {
        //     h: 0,
        //     s: 0,
        //     l: .20,
        //     a: 1,
        //   },
        // }
        event.stopPropagation(); // (prevent conflicts onClose) https://developer.mozilla.org/en-US/docs/Web/API/Event/stopPropagation

        this.props.onChange(color.hex);
    }

    render () {
        return (
            <div>
                <CirclePicker
                    width={this.state.colorPickerAdjustedWidth}
                    color={this.props.color}
                    onChange={this.onChange}
                    colors={this.props.colors}
                />
            </div>
        )
    }
}

ColorPicker.propTypes = {
    onChange: PropTypes.func.isRequired,
    onClose: PropTypes.func,
    colors: PropTypes.arrayOf(PropTypes.string).isRequired
}

/* BASIC POC FOR CUSTOM COLOR (Adding hue, staturation and "current" color swatch, all components updating in unison)

https://codesandbox.io/s/nrjyqz88m0
https://codesandbox.io/s/vj39v365o3

import React from "react";
import { CustomPicker, CirclePicker, SketchPicker, BlockPicker } from "react-color";

import {
    EditableInput,
    Hue,
    Circle,
    Saturation,
    Slider
} from "react-color/lib/components/common";

export const MyPicker = ({ hex, hsl, hsv, onChange }) => {
    const styles = {
        hue: {
            height: 10,
            position: "relative",
            marginBottom: 10
        },
            saturation: {
            width: 100,
            height: 100,
            position: "relative"
        },
            input: {
            height: 34,
            border: `1px solid ${hex}`,
            paddingLeft: 10
        },
            swatch: {
            width: 54,
            height: 38,
            background: hex
        }
    };
    return (
        <div>
            <div style={styles.hue}>
                <Hue hsl={hsl} onChange={onChange} />
            </div>
            <div style={styles.saturation}>
                <Saturation hsl={hsl} hsv={hsv} onChange={onChange} />
            </div>
            <div>
                <CirclePicker hsl={hsl} onChange={onChange} />
            </div>

            <div style={{ display: "flex" }}>
                <div style={styles.swatch} />
            </div>
        </div>
    );
};

export default CustomPicker(MyPicker);

*/
